<app-collapsible [listId]="listId" [itemId]="faq.id" (clickEvent)="handleClick()">
  <ng-container topContent>
    <span class="question">{{ faq.txtPergunta }}</span>
  </ng-container>

  <ng-container bottomContent>
    <p class="answer" [innerHtml]="faq.txtResposta"></p>

    <div class="share-button-container">
      <app-button
        [text]="'Copiar Link'"
        [iconName]="'share-2'"
        [shortPadding]="true"
        [outline]="true"
        (clickEvent)="handleShareButtonClick()"
      ></app-button>
    </div>

    <app-faq-survey [faqId]="faq.id"></app-faq-survey>
  </ng-container>
</app-collapsible>
